















































import {Component, Vue} from "vue-property-decorator";
import {Notification} from "@/entity/Notification";
import {NotificationDto} from "@/dto/NotificationDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import XXHeader from "@/views/KeShangAdmin/XXHeader.vue";
import {getModule} from "vuex-module-decorators";
import {AuthStore} from "@/oauth/AuthStore";
import {CollectCompany} from "@/entity/CollectCompany";
import {Customer} from "@/entity/Customer";
import {CustomerDto} from "@/dto/CustomerDto";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {CustomerStore} from "@/store/CustomerStore";
import { BpmToDoDoneDto } from "@/dto/BpmToDoDoneDto";
import { BpmToDoDoneEntity } from "@/entity/BpmToDoDoneEntity";

@Component({
  components: {XXHeader},
})

export default class PendingNotification extends Vue {
  notifications: Notification[] = [];
  ls = getModule(AuthStore);
  collectCompany = new CollectCompany();
  private customers: Customer[] = [];
  rightDrawerOpen = true;
  su = SecurityUtils;

  get title() {
    return this.$route.params.isread === 'unread' ? '未读消息' : "全部消息";
  }

  refresh() {
    setTimeout(() => {
      this.$router.push({name: 'refresh'})
    }, 1000)
  }

  getTime(data: Date) {
    return this.formatDate(data);
  }

  formatDate(data: Date) {
    //三目运算符
    const Dates = new Date(data);
    //年份
    const Year: number = Dates.getFullYear();
    //月份下标是0-11
    const Months: any = (Dates.getMonth() + 1) < 10 ? '0' + (Dates.getMonth() + 1) : (Dates.getMonth() + 1);
    //具体的天数
    const Day: any = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate();
    //小时
    const Hours = Dates.getHours() < 10 ? '0' + Dates.getHours() : Dates.getHours();
    //分钟
    const Minutes = Dates.getMinutes() < 10 ? '0' + Dates.getMinutes() : Dates.getMinutes();
    //秒
    const Seconds = Dates.getSeconds() < 10 ? '0' + Dates.getSeconds() : Dates.getSeconds();
    //返回数据格式
    return Months + '月' + Day + '日' + Hours + ':' + Minutes;
  }

  fanhui() {
    this.$router.push("/keShangSelect2")
  }

  async read(id: number) {
    const notification = await NotificationDto.findById(id);
    notification.isRead = true;
    await NotificationDto.save(notification);
    // alert("已读");
    await this.findAllNotifications();
    await this.$router.push({path: '/KeShangSelect'});
    sessionStorage.setItem('qingAppName', notification.qingAppName);
  }

  async findAllNotifications() {
    const notification = new Notification();
    notification.userId = SecurityUtils.getLoginUser().username as unknown as number;
    const notifications1 = await NotificationDto.findAll(notification);
    if (this.$route.params.isread === 'unread') {
      this.notifications = notifications1.filter(value => value.isRead !== true);
      this.notifications = this.notifications.filter(value => value.qingAppName != "客商审批");
    } else if (this.$route.params.isread === 'read') {
      this.notifications = notifications1.filter(value => value.isRead === true);
    } else if (this.$route.params.isread === 'approval') {
      const  bpmToDo = await BpmToDoDoneDto.getBpmToDoDone(this.ls.loginUser.username) as any
      if (bpmToDo.data.list.length>0){
        bpmToDo.data.list.filter((item: any)=>{
          const a= new Notification()
          a.qingAppIocns= item.logo
          a.qingAppName= item.appName
          a.title= item.category
          a.date= item.createdDate
          this.notifications.push(a)
        })
      }else {
        // this.notifications = notifications1.filter(value => value.isRead !== true);
        // this.notifications = this.notifications.filter(value => value.qingAppName == "客商审批");
      }
    } else {
      const  bpmToDo = await BpmToDoDoneDto.getBpmToDoDone(this.ls.loginUser.username) as any
      if (bpmToDo.data.list.length>0){
        bpmToDo.data.list.filter((item: any)=>{
          const a= new Notification()
          a.qingAppIocns= item.logo
          a.qingAppName= item.appName
          a.title= item.category
          a.date= item.createdDate
          notifications1.push(a)
        })
      }else {
        // this.notifications = notifications1.filter(value => value.isRead !== true);
        // this.notifications = this.notifications.filter(value => value.qingAppName == "客商审批");
      }
      this.notifications = notifications1;
    }

  }

  mounted() {
    this.findAllNotifications();
  }
}
